import React, { useContext, useEffect, useState, useMemo } from "react";
import { CollapseGroupContext, CollapseContext } from "./Collapse.context";
var Collapse = function (_a) {
    var id = _a.id, children = _a.children;
    var contextGroupValue = useContext(CollapseGroupContext);
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var closeCollapse = function () {
        if (contextGroupValue && contextGroupValue.setActiveCollapse) {
            contextGroupValue.setActiveCollapse(undefined);
        }
        setExpanded(false);
    };
    var openCollapse = function () {
        if (contextGroupValue && contextGroupValue.setActiveCollapse) {
            contextGroupValue.setActiveCollapse(id);
        }
        setExpanded(true);
    };
    var onToggle = function () {
        if (expanded) {
            closeCollapse();
        }
        else {
            openCollapse();
        }
    };
    useEffect(function () {
        if (!contextGroupValue) {
            return;
        }
        if ((contextGroupValue === null || contextGroupValue === void 0 ? void 0 : contextGroupValue.activeCollapse) === id) {
            setExpanded(true);
        }
        else {
            setExpanded(false);
        }
    }, [contextGroupValue, id]);
    var contextValue = useMemo(function () { return ({
        id: id,
        expanded: expanded,
        onToggle: onToggle,
        openCollapse: openCollapse,
        closeCollapse: closeCollapse,
    }); }, [id, expanded, onToggle, openCollapse, closeCollapse]);
    return (React.createElement(CollapseContext.Provider, { value: contextValue }, children));
};
export default Collapse;
